export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-sm"></i>
              </span>
              <span className="text-lg font-heading text-background-50 font-bold">丫丫影院</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed">
              免费高清影视在线观看平台。海量电视剧全集与电影大全，无需注册付费，全集免费看，高清不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#hero" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#carousel" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">精选专题</a>
              <a href="#ranking" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">热播榜单</a>
              <a href="#index" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">影视索引</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">帮助中心</h4>
            <div className="space-y-2.5">
              <a href="#faq" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#about" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">关于丫丫</a>
              <a href="#features" className="block text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">平台特色</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 丫丫影院 yaya.com - 免费电视剧全集电影大全，免费高清在线观看全集
            </p>
            <div className="flex items-center gap-1 text-xs text-background-500">
              <span>本站所有资源均来自互联网，仅供交流学习使用</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}